import { t } from '@lingui/core/macro';
import { Alert, Box, DialogContent, TextArea } from '@pocketlaw/tetris';
import { Field, useFormikContext } from 'formik';
export function Content(props) {
    const { children, error } = props;
    const { isSubmitting } = useFormikContext();
    return (<DialogContent>
      {error && (<Alert appearance="danger" message={t({
                comment: 'Document assistant - feedback dialog - error alert title',
                message: 'An error occured when submitting your feedback. Please, try again later.',
            })}/>)}
      <Box flexDirection="column" gap="xl">
        <Field as={TextArea} label={t({
            message: 'Your feedback',
            comment: 'Document assistant - feedback modal - textarea label',
        })} name="feedback" disabled={isSubmitting}/>
        {children}
      </Box>
    </DialogContent>);
}
